<script setup lang="ts">
import Button from '@/core/components/base/Button.vue'
import LanguageView from '@/core/components/LanguageView.vue'
import { useButtonTranslateClose } from './ButtonTranslateClose'

const { show, doPopupTranslateClose } = useButtonTranslateClose()

function handleTap(Event: PointerEvent) {
  doPopupTranslateClose()
}
</script>

<template>
  <LanguageView lang="th">
    <Button v-show="show" class="button-translate-close" @tap="handleTap">
      <img src="/images/simakatra/th/button-translate-close.gif" />
    </Button>
  </LanguageView>

  <LanguageView lang="en">
    <Button v-show="show" class="button-translate-close en" @tap="handleTap">
      <img src="/images/simakatra/en/button-translate-close.gif" />
    </Button>
  </LanguageView>
</template>

<style scoped>
/* ---------------------------- */
.blink {
  animation: blink 3.5s linear infinite;
}

@keyframes blink {
  0%,
  100% {
    opacity: 0.3;
  }

  50% {
    opacity: 1;
  }
}

/* ---------------------------- */
.button-translate-close {
  position: absolute;
  left: 1086px;
  top: 989px;
}

.button-translate-close.en {
  left: 1048px;
}
</style>
